export enum CommunicationTypes {
    SMS,
    Email,
    Phone,
    'In Person'
  }